import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceAPReturnActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Return/ReturnBrowser")
	}

	render() {
		return (
			<Activity 
				name="WarehousePurchaseReturn"
				RenderedComponent={this.RenderedComponent}
				context="WarehousePurchaseReturn"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceAPReturnActivity)
